<template>
    <div class="receipt-popup form">
        <div class="formrow">
            <EmailInput v-model:value="emailRecipient" @submit="sendReceipt" />
        </div>
        <ReceiptActionButtons
            ref="receiptActionButtons"
            :paymentFor="props.paymentFor"
            :emailRecipient="emailRecipient"
            :locationId="props.locationId"
            :orderId="props.orderId"
            :paymentId="props.paymentId"
            :userIsWaiter="props.userIsWaiter"
            :isPayLater="props.isPayLater"
            :onSendReceiptSuccess="props.closePopup"
            :onPrintSuccess="props.closePopup"
            :hidePrintButtonOnEmailInputStarted="true"
        />
    </div>
</template>

<script setup lang="ts">
    import { PaymentFor } from "@/data/model/Enums";
    import { ref } from "vue";

    import EmailInput from "@/components/elements/EmailInput.vue";
    import ReceiptActionButtons from "@/components/payment/ReceiptActionButtons.vue";

    const props = defineProps<{
        locationId: string;
        paymentFor: PaymentFor;
        orderId?: string;
        paymentId?: string;
        isPayLater: boolean;
        closePopup: () => void;
        userIsWaiter: boolean;
    }>();

    const emailRecipient = ref<string | undefined>();
    const receiptActionButtons = ref<InstanceType<typeof ReceiptActionButtons> | null>(null);

    function sendReceipt() {
        receiptActionButtons.value?.sendReceipt();
    }
</script>

<style lang="scss">
    .receipt-popup {
        .formrow {
            margin-top: 1em;
        }

        .receipt-action-buttons {
            .v-btn {
                margin-top: 1em !important;
            }
        }
    }
</style>
